import * as React from 'react';

export const MinusIcon = (
  // eslint-disable-next-line react/forbid-elements -- Иконка наследует currentColor; внешний SVG не наследует цвет родительского элемента.
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="10" height="10" viewBox="0 0 10 10">
    <rect width="10" height="2" y="4" fillRule="evenodd" rx="1" />
  </svg>
);
